import React from 'react';
import { Route, Switch } from 'react-router';

import OrganizationBucketsPage from './OrganizationBucketsPage';
import OrganizationMembersPage from './OrganizationMembersPage';
import OrganizationReportPage from './OrganizationReportPage';
import routes from '../helpers/ApplicationRoutes';

const OrganizationPage = ({ location }) => (
    <React.Fragment>
        <Switch location={location}>
            <Route
                path={routes.organizationMembers.path}
                component={OrganizationMembersPage}
            />
            <Route
                path={routes.organizationReport.path}
                component={OrganizationReportPage}
            />
            <Route
                path={routes.organizationBuckets.path}
                component={OrganizationBucketsPage}
            />
        </Switch>
    </React.Fragment>
);

export default OrganizationPage;



// WEBPACK FOOTER //
// ./src/pages/OrganizationPage.js